/**
 * @format
 * @Description: 消息事件请求层
 * @Autho: 方证
 * @Date: 2019/12/10
 */

import Request from 'utils/request';

export default class MessageEventsServ {
  static getList(params) {
    return {
      url: 'api/message/v1/event/page',
      method: 'GET',
      data: {
        filter: {}
      }
    };
  }
  static getListEventType(params) {
    return Request({
      method: 'get',
      url: `api/message/v1/event-type/page`,
      data: params
    });
  }
  static saveForm(params) {
    if (params.editing) {
      return {
        url: 'api/message/v1/event/',
        method: 'put'
      };
    } else {
      return {
        url: 'api/message/v1/event',
        method: 'POST'
      };
    }
  }
  static notice(params) {
    return {
      url: 'api/message/v1/event/{id}/status?status={updateStatus}',
      method: 'put'
    };
  }
  static delete(params) {
    return {
      url: 'api/message/v1/event/{id}',
      method: 'delete'
    };
  }
  //获取领域
  static getDomain(params) {
    return {
      url: 'api/basicdata/v1/meta/domain',
      method: 'GET'
    };
  }
}



// WEBPACK FOOTER //
// ./src/pages/MessageManage/MessageEvents/MessageEventsServ.js